// import React from "react";

// export const Works = () => {
//   return (
//     <div>
//       {/* How it works */}
//       <section className="py-20 bg-white">
//         <div className="container mx-auto px-6 text-center">
//           <h2 className="text-4xl font-display text-[#C2185B] mb-12">
//             How It Works
//           </h2>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
//             <div className="flex flex-col items-center">
//               <div className="bg-[#F8BBD0] p-6 rounded-full">
//                 <svg
//                   className="h-12 w-12 text-[#C2185B]"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                   ></path>
//                 </svg>
//               </div>
//               <h3 className="mt-6 text-2xl font-bold text-[#4d4d4d]">
//                 1. Register
//               </h3>
//               <p className="mt-2 text-gray-600">
//                 Create your detailed profile in minutes.
//               </p>
//             </div>

//             <div className="flex flex-col items-center">
//               <div className="bg-[#F8BBD0] p-6 rounded-full">
//                 <svg
//                   className="h-12 w-12 text-[#C2185B]"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                   ></path>
//                 </svg>
//               </div>
//               <h3 className="mt-6 text-2xl font-bold text-[#4d4d4d]">
//                 2. Connect
//               </h3>
//               <p className="mt-2 text-gray-600">
//                 Search and connect with matches you like.
//               </p>
//             </div>

//             <div className="flex flex-col items-center">
//               <div className="bg-[#F8BBD0] p-6 rounded-full">
//                 <svg
//                   className="h-12 w-12 text-[#C2185B]"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                   ></path>
//                 </svg>
//               </div>
//               <h3 className="mt-6 text-2xl font-bold text-[#4d4d4d]">
//                 3. Marry
//               </h3>
//               <p className="mt-2 text-gray-600">
//                 Start your happily ever after.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// import React from "react";

// export const Works = () => {
//   return (
//     <div>
//       {/* How it works */}
//       <section className="py-20 bg-gradient-to-b from-[#FFF5F8] to-[#FDE7EF]">
//         <div className="container mx-auto px-6 text-center">
//           {/* Heading */}
//           <h2
//             data-aos="fade-down"
//             className="text-3xl md:text-4xl font-extrabold tracking-wide text-gray-900 mb-14"
//           >
//             <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-700 via-rose-600 to-red-600">
//               How It Works
//             </span>
//           </h2>

//           {/* Cards */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
//             {/* Step 1 */}
//             <div className="relative bg-gradient-to-br from-[#2B0A14] via-[#3C0F1E] to-[#4B1326] text-white p-8 rounded-2xl shadow-xl hover:shadow-pink-500/30 transform hover:-translate-y-2 transition-all duration-300">
//               <div className="bg-gradient-to-br from-pink-500 to-rose-500 p-4 rounded-full inline-block mb-5">
//                 <svg
//                   className="h-10 w-10 text-white"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                   ></path>
//                 </svg>
//               </div>
//               <h3 className="text-xl font-bold mb-2">1. Register</h3>
//               <p className="text-gray-300 text-sm">
//                 Create your personalized profile in just minutes and start your
//                 journey.
//               </p>

//               <div className="absolute inset-0 rounded-2xl border border-rose-600 opacity-0 hover:opacity-40 transition-opacity duration-500"></div>
//             </div>

//             {/* Step 2 */}
//             <div className="relative bg-gradient-to-br from-[#2B0A14] via-[#3C0F1E] to-[#4B1326] text-white p-8 rounded-2xl shadow-xl hover:shadow-pink-500/30 transform hover:-translate-y-2 transition-all duration-300">
//               <div className="bg-gradient-to-br from-rose-500 to-pink-500 p-4 rounded-full inline-block mb-5">
//                 <svg
//                   className="h-10 w-10 text-white"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                   ></path>
//                 </svg>
//               </div>
//               <h3 className="text-xl font-bold mb-2">2. Connect</h3>
//               <p className="text-gray-300 text-sm">
//                 Browse verified profiles and connect with matches that suit you
//                 best.
//               </p>

//               <div className="absolute inset-0 rounded-2xl border border-rose-600 opacity-0 hover:opacity-40 transition-opacity duration-500"></div>
//             </div>

//             {/* Step 3 */}
//             <div className="relative bg-gradient-to-br from-[#2B0A14] via-[#3C0F1E] to-[#4B1326] text-white p-8 rounded-2xl shadow-xl hover:shadow-pink-500/30 transform hover:-translate-y-2 transition-all duration-300">
//               <div className="bg-gradient-to-br from-pink-500 to-red-500 p-4 rounded-full inline-block mb-5">
//                 <svg
//                   className="h-10 w-10 text-white"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                   ></path>
//                 </svg>
//               </div>
//               <h3 className="text-xl font-bold mb-2">3. Marry</h3>
//               <p className="text-gray-300 text-sm">
//                 Once you’ve found your soulmate, take the next beautiful step
//                 together.
//               </p>

//               <div className="absolute inset-0 rounded-2xl border border-rose-600 opacity-0 hover:opacity-40 transition-opacity duration-500"></div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

import React from "react";

export const Works = () => {
  return (
    <div>
      {/* How it works */}
      <section className="py-20 bg-gradient-to-b from-[#FFF5F8] to-[#FDE7EF]">
        <div className="container mx-auto px-6 text-center">
          {/* Heading */}
          <h2
            data-aos="fade-down"
            className="text-3xl md:text-4xl font-extrabold tracking-wide text-gray-900 mb-14"
          >
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-700 via-rose-600 to-red-600">
              {/* How It Works */}
              <span className="text-black">How it</span> Works
            </span>
            {/* <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500">
              <span className="text-black">How it</span> Works
            </span> */}
          </h2>

          {/* Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
            {/* Step 1 - Register */}
            <div className="relative bg-gradient-to-br from-[#2b1055] via-[#3a0ca3] to-[#5f0f40] text-white p-8 rounded-2xl shadow-xl hover:shadow-indigo-400/40 transform hover:-translate-y-2 transition-all duration-300">
              <div className="bg-gradient-to-br from-indigo-400 to-violet-500 p-4 rounded-full inline-block mb-5 shadow-md">
                <svg
                  className="h-10 w-10 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">1. Register</h3>
              <p className="text-gray-200 text-sm">
                Create your detailed profile in minutes and start your journey
                toward love.
              </p>
              <div className="absolute inset-0 rounded-2xl border border-indigo-400 opacity-0 hover:opacity-40 transition-opacity duration-500"></div>
            </div>

            {/* Step 2 - Connect */}
            <div className="relative bg-gradient-to-br from-[#5f0f40] via-[#9a031e] to-[#fb5607] text-white p-8 rounded-2xl shadow-xl hover:shadow-rose-400/40 transform hover:-translate-y-2 transition-all duration-300">
              <div className="bg-gradient-to-br from-rose-400 to-pink-500 p-4 rounded-full inline-block mb-5 shadow-md">
                <svg
                  className="h-10 w-10 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">2. Connect</h3>
              <p className="text-gray-200 text-sm">
                Explore profiles and connect with compatible matches near you.
              </p>
              <div className="absolute inset-0 rounded-2xl border border-rose-400 opacity-0 hover:opacity-40 transition-opacity duration-500"></div>
            </div>

            {/* Step 3 - Marry */}
            <div className="relative bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460] text-white p-8 rounded-2xl shadow-xl hover:shadow-cyan-400/40 transform hover:-translate-y-2 transition-all duration-300">
              <div className="bg-gradient-to-br from-cyan-400 to-blue-500 p-4 rounded-full inline-block mb-5 shadow-md">
                <svg
                  className="h-10 w-10 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">3. Marry</h3>
              <p className="text-gray-200 text-sm">
                Begin your beautiful journey together and celebrate your love
                forever.
              </p>
              <div className="absolute inset-0 rounded-2xl border border-cyan-400 opacity-0 hover:opacity-40 transition-opacity duration-500"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
